export const switchToPlainTextMenuItem = "W7a";
export default {switchToPlainTextMenuItem};